import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-chambers-icon"
};
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.4",
  d: "M20 11.25V13.75H0V11.25C0 9.86816 1.11816 8.75 2.5 8.75H17.5C18.8818 8.75 20 9.86816 20 11.25Z",
  fill: "#7442EC"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M0 13.75V18.125C0 18.4717 0.27832 18.75 0.625 18.75H1.875C2.22168 18.75 2.5 18.4717 2.5 18.125V16.25H17.5V18.125C17.5 18.4717 17.7783 18.75 18.125 18.75H19.375C19.7217 18.75 20 18.4717 20 18.125V13.75H0ZM3.125 8.75V6.25C3.125 5.56152 3.68652 5 4.375 5H8.125C8.81348 5 9.375 5.56152 9.375 6.25V8.75H10.625V6.25C10.625 5.56152 11.1865 5 11.875 5H15.625C16.3135 5 16.875 5.56152 16.875 6.25V8.75H17.5C17.9579 8.75 18.3811 8.88176 18.75 9.09621V2.5C18.75 1.81152 18.1885 1.25 17.5 1.25H2.5C1.81152 1.25 1.25 1.81152 1.25 2.5V9.09621C1.61887 8.88176 2.04207 8.75 2.5 8.75H3.125Z",
  fill: "#7442EC"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const uikitChambers = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitChambers as default
};
//# sourceMappingURL=uikit-chambers.vue.es.js.map
